import React from "react";
import PropTypes from "prop-types";

/**
 * 트위터 카드 메타데이터 컴포넌트
 * 셀러 컬렉션 페이지의 트위터 공유를 위한 메타데이터를 제공합니다.
 */
export default function SellerCollectionTwitterCard({
  collection,
  title = "후루츠패밀리 셀러 컬렉션",
}) {
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fruitsfamilyco" />
      <meta name="twitter:title" content={title} />
      <meta
        name="twitter:description"
        content={
          (collection && collection.description) ||
          "후루츠패밀리의 다양한 셀러 컬렉션을 만나보세요. 인기 셀러들의 상품을 한눈에 확인할 수 있습니다."
        }
      />
      {collection && collection.resizedBigImage && (
        <meta name="twitter:image" content={collection.resizedBigImage} />
      )}
      <meta name="twitter:image:alt" content={title} />
    </>
  );
}

SellerCollectionTwitterCard.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string,
    sub_title: PropTypes.string,
    description: PropTypes.string,
    resizedBigImage: PropTypes.string,
  }),
  title: PropTypes.string,
};
